// import { flushSync } from "react-dom"
import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import { UnorderedListOutlined, GlobalOutlined, PlusOutlined } from '@ant-design/icons'
import useGlobalConfigStore from '@/stores/globalConfig'
import useStationListStore from '@/stores/stationList'
import { Station } from '@/type/stationType'
import { useTranslation } from 'react-i18next'
import { SITE_STATUS } from '@/utils/const'
import useMessage from '@/hooks/useMessage'
import CreateSite from './components/CreateSite'
import SiteTable from './components/SiteTable'
import SiteFilter from './components/SiteFilter'
import Map from './components/Map'

const StationList: React.FC = () => {
  const { t } = useTranslation()
  const { message } = useMessage()
  const [activeButton, setActiveButton] = useState<string>('list') // 初始活动按钮为"list"
  const initFinished = useGlobalConfigStore(state => state.initFinished)
  const station = useStationListStore(state => state.station)
  const stationInit = useStationListStore(state => state.stationInit)
  const [createOpen, setCreateOpen] = useState(false)

  const [stationList, setStationList] = useState<Station[]>([])
  const [runStatus, setRunStatus] = useState<SITE_STATUS>(SITE_STATUS.ALL)
  const [showStationList, setShowStationList] = useState<Station[]>([])

  useEffect(() => {
    if (initFinished) {
      setStationList(station)
    }
  }, [initFinished])

  const onSearch = (run_status: SITE_STATUS, name: string, address: string, type: string) => {
    setRunStatus(run_status)
    setStationList(
      station.filter(
        item =>
          item.station_name.toLowerCase().includes(name.toLowerCase()) &&
          (item.postal_code.includes(address) || item.address.toLowerCase().includes(address.toLowerCase())) &&
          (type === '' || item.station_type === type)
      )
    )
  }

  useEffect(() => {
    if (runStatus === SITE_STATUS.ALL) {
      setShowStationList(stationList)
    } else if (runStatus === SITE_STATUS.FAVOURITE) {
      setShowStationList(stationList.filter(item => item.is_collect == 1))
    } else {
      setShowStationList(stationList.filter(item => item.run_status === runStatus))
    }
  }, [stationList, runStatus])

  const handleAddSite = () => {
    setCreateOpen(false)
    stationInit().catch(e => {
      console.log(e)
      message.error(e.message || e.msg || e)
    })
  }

  return (
    <div id='StationLists' className='app-loading'>
      <div className='StationLists-header'>
        <div className='StationLists-header-left'>
          <Button type={activeButton === 'list' ? 'primary' : 'default'} onClick={() => setActiveButton('list')}>
            <UnorderedListOutlined /> {t('menu.siteList')}
          </Button>
          <Button type={activeButton === 'map' ? 'primary' : 'default'} onClick={() => setActiveButton('map')}>
            <GlobalOutlined /> {t('menu.siteMap')}
          </Button>
        </div>
        <div className='StationLists-header-right'>
          <Button type='primary' onClick={() => setCreateOpen(true)}>
            {/* <Button type='primary' onClick={() => stationInit()}> */}
            <PlusOutlined />
            {t('site.createSite')}
          </Button>
        </div>
      </div>
      <SiteFilter stations={stationList} onSearch={onSearch} />
      {/* <SiteFilter
        setShowStationList={setShowStationList}
        stationListState={stationListState}
        showStationList={showStationList}
      /> */}
      <div style={{ height: '10px' }}></div>
      {activeButton === 'list' && <SiteTable station={showStationList} />}
      {activeButton === 'map' && <Map station={showStationList} />}
      <CreateSite open={createOpen} onClose={() => setCreateOpen(false)} onAdd={handleAddSite} />
    </div>
  )
}

export default StationList
